import { Button } from '@zep/ui';
import { StoreAssetSubCategory } from '../../../../types/StoreTypes';
import S from './AppCategoryTagList.module.scss';
const AppCategoryTagList = (props: AppCategoryTagListProps) => {
  const {
    items,
    currentItem,
    onCategoryChange,
    style
  } = props;
  return <ul className={S.category_wrapper} style={style} data-sentry-component="AppCategoryTagList" data-sentry-source-file="AppCategoryTagList.tsx">
      {items.map(item => <li key={item.value}>
          <Button variant={item.value === currentItem ? 'secondary' : 'sub'} leftSlot={item.icon} rounded={true} onClick={() => onCategoryChange(item.value)}>
            {item.name}
          </Button>
        </li>)}
    </ul>;
};
export default AppCategoryTagList;
type AppCategoryTagListProps = {
  items: readonly StoreAssetSubCategory[];
  currentItem?: number;
  onCategoryChange: (newSubCategory?: number) => void;
  style?: React.CSSProperties;
};